<template>
  <div class="products" id="products">
    <h1 v-if="isHomeVersionBar" class="products-title section-title">
      {{ $t("products.ourLetter") }}
    </h1>
    <div class="products-title section-image logo">
      <div>
        <img
          v-if="!isHomeVersionBar && settings && settings.icons && !isAdmin"
          :src="settings.icons.logo"
          alt="logo"
          :style="[
            {
              width: logoWidthTheme
            }
          ]"
        />
      </div>
    </div>

    <DefaultSlider
      v-if="isRestaurantOpened"
      :menus="menus"
      :menuGroup="menuGroup"
      :scheduleByMenu="scheduleByMenu"
      :scheduleByMenuGroup="scheduleByMenuGroup"
      :disableAddFood="disableAddFood"
      :disableAddDrinks="disableAddDrinks"
      :disableAddDessert="disableAddDessert"
      :food="food"
      :drinks="drinks"
      :dessert="dessert"
      :sortedMenuList="sortedSliderList"
      :validFood="validFood"
      :validDrinks="validDrinks"
      :validDessert="validDessert"
      @onTab="onTab"
      @onMenuGroupTab="onMenuGroupTab"
      @setColor="setColor($event)"
    ></DefaultSlider>

    <PremiumSlider
      v-if="isRestaurantOpened"
      :menus="menus"
      :menuGroup="menuGroup"
      :scheduleByMenu="scheduleByMenu"
      :scheduleByMenuGroup="scheduleByMenuGroup"
      :disableAddFood="disableAddFood"
      :disableAddDrinks="disableAddDrinks"
      :disableAddDessert="disableAddDessert"
      :food="food"
      :drinks="drinks"
      :dessert="dessert"
      :sortedMenuList="sortedSliderList"
      :validFood="validFood"
      :validDrinks="validDrinks"
      :validDessert="validDessert"
      @onTab="onTab"
      @onMenuGroupTab="onMenuGroupTab"
      @setColor="setColor($event)"
    ></PremiumSlider>

    <BarSlider
      v-if="isRestaurantOpened"
      :menus="menus"
      :menuGroup="menuGroup"
      :scheduleByMenu="scheduleByMenu"
      :scheduleByMenuGroup="scheduleByMenuGroup"
      :disableAddFood="disableAddFood"
      :disableAddDrinks="disableAddDrinks"
      :disableAddDessert="disableAddDessert"
      :dessert="dessert"
      :food="food"
      :drinks="drinks"
      :sortedMenuList="sortedSliderList"
      :validFood="validFood"
      :validDrinks="validDrinks"
      :validDessert="validDessert"
      @onTab="onTab"
      @onMenuGroupTab="onMenuGroupTab"
      @setColor="setColor($event)"
    ></BarSlider>

    <div
      v-if="isRestaurantOpened"
      class="mb-div-width mobile-flex-div mb-2 search-width"
    >
      <v-text-field
        v-model="search"
        :label="$t('products.findProduct')"
        solo
        single-line
        hide-details
        append-icon="mdi-magnify"
        @input="universalSearch()"
      ></v-text-field>
    </div>

    <v-alert v-if="isRestaurantClosed" type="warning" outlined prominent>
      <b>{{ $t("products.restaurantIsClosed") }}</b>
    </v-alert>
    <div
      align="center"
      v-if="isHomeVersionPremium"
      class="selected-slider-item"
    >
      <span :style="{ color: isAdmin ? '#000' : titleLetterColorTheme }">
        {{ selectedProductTypeName }}
      </span>
    </div>
    <ul
      v-if="isRestaurantOpened"
      class="products-accordion"
      :style="{
        'border-radius':
          isHomeVersionPremium || isHomeVersionBar ? '20px' : '0px'
      }"
    >
      <li
        v-for="(category, index) in categories"
        :key="index"
        class="accordion-item"
        v-show="
          productTypeSelected && search.length === 0 && !selectedMenuGroup
        "
        :id="index + '_default'"
        :style="setCategoryStyle(index)"
      >
        <button
          :ref="categories.length == 1 ? 'accordionItemBtn' : ''"
          type="button"
          :class="
            isTypeDrink
              ? `accordion-item-toggle-drink`
              : 'accordion-item-toggle'
          "
          @click="
            toggleAccordionItem($event);
            toggle(index);
          "
        >
          <h2
            class="category-name collapse-title"
            :style="{
              color:
                isHomeVersionPremium || isHomeVersionBar ? '#020202' : '#ffffff'
            }"
          >
            {{ translate("name", category) }}
            <font-awesome-icon
              class="collapse-icon"
              :icon="category.toggleAccordion ? 'angle-up' : 'angle-down'"
              :style="{
                color:
                  isHomeVersionPremium || isHomeVersionBar
                    ? '#020202'
                    : '#ffffff',
                fontSize: 25
              }"
            />
          </h2>
        </button>

        <ul
          class="accordion-item-content"
          style="max-height: auto"
          :id="`content_` + index"
        >
          <ListDrinks
            v-if="isTypeDrink && !disableAddDrinks"
            :category-name="category.name"
            :drinks-by-sub-category="getDrinksByCategory(category.id)"
            :sub-categories="subCategoriesCollection"
            :isAdmin="isAdmin"
          ></ListDrinks>

          <ListFood
            v-if="isTypeFood && !disableAddFood"
            :category-name="category.name"
            :food-by-category="getFoodByCategory(category.id)"
            :sub-categories="subCategoriesCollection"
            :isAdmin="isAdmin"
          ></ListFood>

          <ListDessert
            v-if="isTypeDessert && !disableAddDessert"
            :category-name="category.name"
            :dessert-by-category="getDessertByCategory(category.id)"
            :sub-categories="subCategoriesCollection"
            :isAdmin="isAdmin"
          ></ListDessert>
          <template v-for="(menu, index) in menus">
            <div :key="`menu_list_${index}`">
              <ListDrinks
                v-if="productTypeSelected === menu.id && displayMenu(menu)"
                :category-name="category.name"
                :drinks-by-sub-category="getDrinksByCategory(category.id)"
                :sub-categories="subCategoriesCollection"
                :isAdmin="isAdmin"
              ></ListDrinks>

              <ListFood
                v-if="productTypeSelected === menu.id && displayMenu(menu)"
                :category-name="category.name"
                :food-by-category="getFoodByCategory(category.id)"
                :sub-categories="subCategoriesCollection"
                :isAdmin="isAdmin"
              ></ListFood>

              <ListDessert
                v-if="productTypeSelected === menu.id && displayMenu(menu)"
                :category-name="category.name"
                :dessert-by-category="getDessertByCategory(category.id)"
                :sub-categories="subCategoriesCollection"
                :isAdmin="isAdmin"
              ></ListDessert>
            </div>
          </template>
        </ul>
      </li>
      <li
        v-show="
          selectedMenuGroup &&
            selectedMenuGroup === menu.id &&
            search.length === 0 &&
            !productTypeSelected
        "
        v-for="(menu, index) in menuGroup"
        :key="`menuGroup${index}`"
        class="accordion-item"
        :id="`menugroup_${index}`"
        :style="[{ 'background-color': secondaryColor }]"
      >
        <ul
          class="accordion-item-content"
          style="max-height: 100% !important"
          :id="`menugroup_ul_${index}`"
        >
          <template>
            <div :key="`menugroup_product_list_${index}`">
              <ListMenuGroup
                :menuGroup="menu"
                :drinks="drinksCollection"
                :dessert="dessertCollection"
                :starter="starterProduct"
                :maincourse="maincourseProduct"
                :isAdmin="isAdmin"
              ></ListMenuGroup>
            </div>
          </template>
        </ul>
      </li>

      <li class="accordion-item" v-if="search.length > 0" id="search_product">
        <ul class="accordion-item-content" style="max-height: 100%">
          <ListDrinks
            v-if="searchDrinks.length > 0"
            :drinks-by-sub-category="searchDrinks"
            :sub-categories="subCategoriesCollection"
            :isAdmin="isAdmin"
          ></ListDrinks>

          <ListFood
            v-if="searchFoods.length > 0"
            :food-by-category="searchFoods"
            :sub-categories="subCategoriesCollection"
            :isAdmin="isAdmin"
          ></ListFood>

          <ListDessert
            v-if="searchPostres.length > 0"
            :dessert-by-category="searchPostres"
            :sub-categories="subCategoriesCollection"
            :isAdmin="isAdmin"
          ></ListDessert>
        </ul>
      </li>
      <li>
        <div v-if="showEmptyMsg" class="no-record-message">
          {{ $t("common.noRecordMessage") }}
        </div>
        <div
          v-show="!showEmptyMsg && search.length === 0"
          v-for="(menu, index) in menus"
          :key="index"
        >
          <div v-if="haveProducts(menu)" class="no-record-message">
            {{ $t("common.noRecordMessage") }}
          </div>
        </div>
      </li>
    </ul>

    <SelectItem
      :cubataItem="cubataItem"
      @selectDrink="onSelectDrink"
    ></SelectItem>
  </div>
</template>

<script>
import ListDrinks from "@/components/public/products/List/ListDrinks";
import ListFood from "@/components/public/products/List/ListFood";
import ListDessert from "@/components/public/products/List/ListDessert";
import SelectItem from "./SelectItems/CubataDialog.vue";
import DefaultSlider from "@/components/public/products/Slider/DefaultSlider";
import PremiumSlider from "./Slider/PremiumSlider.vue";
import BarSlider from "./Slider/BarSlider.vue";
import ListMenuGroup from "@/components/public/products/List/ListMenuGroup";
import { subCategoriesCollection } from "@/collections/subCategories";
import { uiMenuOrderCollection } from "@/collections/uiMenuOrder";
import { scheduleFoodCollection } from "@/collections/scheduleFood";
import { scheduleDrinksCollection } from "@/collections/scheduleDrinks";
import { scheduleDessertCollection } from "@/collections/scheduleDessert";
import { scheduleByMenuCollection } from "@/collections/scheduleByMenu";
import { scheduleMenuGroupCollection } from "@/collections/scheduleMenuGroup";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
import { drinksCollection } from "@/collections/drinks";
import { menusCollection } from "@/collections/menus";
import { menuGroupCollection } from "@/collections/menuGroup";
import { categoriesCollection } from "@/collections/categories";

export default {
  name: "Products",
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ListFood,
    ListDrinks,
    ListDessert,
    SelectItem,
    DefaultSlider,
    BarSlider,
    PremiumSlider,
    ListMenuGroup
  },
  data() {
    return {
      drinks: [],
      food: [],
      dessert: [],
      categoriesCollection: [],
      subCategoriesCollection: [],
      productTypeSelected: "",
      productTypeSelectedName: "",
      lastSubcategoryId: "",
      scheduleDrinks: [],
      scheduleFood: [],
      scheduleDessert: [],
      scheduleByMenu: [],
      scheduleByMenuGroup: [],
      menus: [],
      search: "",
      allproducts: [],
      showEmptyMsg: false,
      searchFoods: [],
      searchDrinks: [],
      searchPostres: [],
      menuGroup: [],
      selectedMenuGroup: "",
      selectedMenuGroupName: null,
      primaryColor: "",
      secondaryColor: "",
      logoWidth: this.logoWidthTheme,
      logoHeight: this.logoHeightTheme,
      uiMenuOrder: []
    };
  },
  firestore() {
    return {
      drinks: drinksCollection.orderBy("sort"),
      food: foodCollection.orderBy("sort"),
      dessert: dessertCollection.orderBy("sort"),
      categoriesCollection: categoriesCollection.orderBy("sort"),
      subCategoriesCollection: subCategoriesCollection.orderBy("sort"),
      scheduleDrinks: scheduleDrinksCollection,
      scheduleFood: scheduleFoodCollection,
      scheduleDessert: scheduleDessertCollection,
      scheduleByMenu: scheduleByMenuCollection,
      menus: menusCollection.where("active", "==", true),
      menuGroup: menuGroupCollection.where("active", "==", true),
      scheduleByMenuGroup: scheduleMenuGroupCollection,
      uiMenuOrder: uiMenuOrderCollection
        .where("active", "==", true)
        .orderBy("sort")
    };
  },
  computed: {
    validFood() {
      let valid = false;
      let filterProduct = this.food.filter(item => {
        if (item.stock > 0 && item.canBeShowInFood) {
          return item;
        }
      });
      if (filterProduct.length > 0) {
        valid = true;
      }
      return valid;
    },
    validDrinks() {
      let valid = false;
      let filterProduct = this.drinks.filter(item => {
        if (item.stock > 0 && item.canBeShowInDrinks) {
          return item;
        }
      });
      if (filterProduct.length > 0) {
        valid = true;
      }
      return valid;
    },
    validDessert() {
      let valid = false;
      let filterProduct = this.dessert.filter(item => {
        if (item.stock > 0 && item.canBeShowInDessert) {
          return item;
        }
      });
      if (filterProduct.length > 0) {
        valid = true;
      }
      return valid;
    },
    selectedProductTypeName() {
      if (this.selectedMenuGroupName !== null) {
        return this.selectedMenuGroupName;
      }
      if (this.productTypeSelectedName !== null) {
        return this.productTypeSelectedName;
      }
      return "";
    },
    drinksCollection() {
      let fromMenu = this.menus.find(x => x.id === this.productTypeSelected);
      if (fromMenu) {
        return this.drinks.filter(x => fromMenu.drink_ids.includes(x.id));
      }

      let fromMenuGroup = this.menuGroup.find(
        x => x.id === this.selectedMenuGroup
      );
      let drinks = [];
      if (fromMenuGroup) {
        fromMenuGroup.drink_ids.forEach(x => {
          let drinkFound = this.drinks.find(item => {
            return item.id === x.id;
          });
          if (drinkFound) {
            drinkFound.additional_charge = x.additional_charge
              ? parseFloat(x.additional_charge)
              : parseInt(0);
            drinks.push(drinkFound);
          }
        });
        return drinks;
      }

      return this.drinks;
    },
    foodCollection() {
      let fromMenu = this.menus.find(x => x.id === this.productTypeSelected);
      if (fromMenu) {
        return this.food.filter(x => fromMenu.food_ids.includes(x.id));
      }
      return this.food;
    },
    dessertCollection() {
      let fromMenu = this.menus.find(x => x.id === this.productTypeSelected);
      if (fromMenu) {
        return this.dessert.filter(x => fromMenu.dessert_ids.includes(x.id));
      }

      let fromMenuGroup = this.menuGroup.find(
        x => x.id === this.selectedMenuGroup
      );
      let dessert = [];
      if (fromMenuGroup) {
        fromMenuGroup.dessert_ids.forEach(x => {
          let dessertFound = this.dessert.find(item => {
            return item.id === x.id;
          });
          if (dessertFound) {
            dessertFound.additional_charge = x.additional_charge
              ? parseFloat(x.additional_charge)
              : parseInt(0);
            dessert.push(dessertFound);
          }
        });
        return dessert;
      }
      return this.dessert;
    },
    cubataItem() {
      return this.$store.state.cubataItem;
    },
    isTypeFood() {
      return this.productTypeSelected === this.$store.state.productTypeIds.food;
    },
    isTypeDrink() {
      return (
        this.productTypeSelected === this.$store.state.productTypeIds.drinks
      );
    },
    isTypeDessert() {
      return (
        this.productTypeSelected === this.$store.state.productTypeIds.dessert
      );
    },
    categories() {
      let self = this;
      // When a product type is selected it will automatically show the categories
      return this.categoriesCollection.filter(category => {
        // for menus
        if (!self.isTypeFood && !self.isTypeDrink && !self.isTypeDessert) {
          return (
            self.haveDrinks(category.id) ||
            self.haveFood(category.id) ||
            self.haveDessert(category.id)
          );
        }

        if (
          category.product_type_id ===
            self.$store.state.productTypeIds.drinks &&
          category.product_type_id === self.productTypeSelected
        ) {
          return self.haveDrinks(category.id);
        }

        if (
          category.product_type_id === self.$store.state.productTypeIds.food &&
          category.product_type_id === self.productTypeSelected
        ) {
          return self.haveFood(category.id);
        }

        if (
          category.product_type_id ===
            self.$store.state.productTypeIds.dessert &&
          category.product_type_id === self.productTypeSelected
        ) {
          return self.haveDessert(category.id);
        }

        return false;
      });
    },
    isRestaurantClosed() {
      return (
        (this.disableAddDrinks || !this.displayBebidas()) &&
        (this.disableAddFood || !this.displayComidas()) &&
        (this.disableAddDessert || !this.displayPostres()) &&
        this.disableMenuAllMenu &&
        this.disableMenuAllMenuGroup
      );
    },
    isRestaurantOpened() {
      return (
        (!this.disableAddDrinks && this.displayBebidas()) ||
        (!this.disableAddFood && this.displayComidas()) ||
        (!this.disableAddDessert && this.displayPostres()) ||
        !this.disableMenuAllMenu ||
        !this.disableMenuAllMenuGroup ||
        this.isOnlyMenu
      );
    },
    disableAddFood() {
      return this.disableProducts(this.scheduleFood);
    },
    disableAddDrinks() {
      return this.disableProducts(this.scheduleDrinks);
    },
    disableAddDessert() {
      return this.disableProducts(this.scheduleDessert);
    },
    disableMenuAllMenu() {
      let array = [];
      this.menus.forEach(menu => {
        let menuSchedule = this.scheduleByMenu.find(x => x.menuId === menu.id);

        if (menuSchedule) {
          let menuVar =
            this.displayMenu(menu) && !this.disableMenu(menuSchedule.schedule);
          array.push(menuVar);
        }
      });

      let checker = array => array.every(v => v === false);
      return array && array.length > 0 ? checker(array) : false;
    },
    disableMenuAllMenuGroup() {
      let array = [];
      this.menuGroup.forEach(menu => {
        let menuGroupSchedule = this.scheduleByMenuGroup.find(
          x => x.menuId === menu.id
        );

        if (menuGroupSchedule) {
          let menuGroupVar =
            this.displayMenu(menu) &&
            !this.disableMenu(menuGroupSchedule.schedule);
          array.push(menuGroupVar);
        }
      });

      let checker = array => array.every(v => v === false);
      return array && array.length > 0 ? checker(array) : false;
    },
    starterProduct() {
      let fromMenuGroup = this.menuGroup.find(
        x => x.id === this.selectedMenuGroup
      );
      let starters = [];

      if (fromMenuGroup) {
        fromMenuGroup.starter_ids.forEach(x => {
          let start = this.food.find(item => {
            return item.id === x.id;
          });
          if (start) {
            start.additional_charge = x.additional_charge
              ? parseFloat(x.additional_charge)
              : parseInt(0);
            starters.push(start);
          }
        });
        return starters;
      }
      return starters;
    },
    maincourseProduct() {
      let fromMenuGroup = this.menuGroup.find(
        x => x.id === this.selectedMenuGroup
      );
      let maincourse = [];
      if (fromMenuGroup) {
        fromMenuGroup.maincourse_ids.forEach(x => {
          let main = this.food.find(item => {
            return item.id === x.id;
          });
          if (main) {
            main.additional_charge = x.additional_charge
              ? parseFloat(x.additional_charge)
              : parseInt(0);
            maincourse.push(main);
          }
        });
        return maincourse;
      }
      return maincourse;
    },
    sortedSliderList() {
      return this.uiMenuOrder?.filter(menu => {
        if (
          menu !== undefined &&
          menu.type === "menu_group" &&
          !this.disableMenuGroup(menu) &&
          this.displayMenu(menu) &&
          this.validMenuGroupProducts(menu)
        ) {
          return menu;
        }
        if (
          menu !== undefined &&
          menu.type === "menus" &&
          !this.disableMenuByMenu(menu) &&
          this.displayMenu(menu) &&
          this.validMenuProducts(menu)
        ) {
          return menu;
        }
        if (
          menu !== undefined &&
          menu.type === "principal" &&
          menu.id === this.productTypeIds.food &&
          !this.disableAddFood &&
          this.displayComidas() &&
          this.validFood
        ) {
          return menu;
        }
        if (
          menu !== undefined &&
          menu.type === "principal" &&
          menu.id === this.productTypeIds.drinks &&
          !this.disableAddDrinks &&
          this.displayBebidas() &&
          this.validDrinks
        ) {
          return menu;
        }
        if (
          menu !== undefined &&
          menu.type === "principal" &&
          menu.id === this.productTypeIds.dessert &&
          !this.disableAddDessert &&
          this.displayPostres() &&
          this.validDessert
        ) {
          return menu;
        }
      });
    }
  },
  watch: {
    scheduleDrinks: {
      // This will let Vue know to look inside the array
      deep: true,

      handler() {
        this.selectEnableTab();
      }
    },
    scheduleFood: {
      // This will let Vue know to look inside the array
      deep: true,

      handler() {
        this.selectEnableTab();
      }
    },
    scheduleByMenu: {
      // This will let Vue know to look inside the array
      deep: true,

      handler() {
        this.selectEnableTab();
      }
    },
    scheduleDessert: {
      // This will let Vue know to look inside the array
      deep: true,

      handler() {
        this.selectEnableTab();
      }
    },
    scheduleByMenuGroup: {
      // This will let Vue know to look inside the array
      deep: true,

      handler() {
        this.selectEnableTab();
      }
    },
    sortedSliderList: {
      // This will let Vue know to look inside the array
      deep: true,

      handler() {
        this.selectEnableTab();
      }
    }
  },
  methods: {
    disableMenuByMenu(menu) {
      let menuSchedule = this.scheduleByMenu.find(x => x.menuId === menu.id);
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    disableMenuGroup(menu) {
      let menuSchedule = this.scheduleByMenuGroup.find(
        x => x.menuId === menu.id
      );
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    setCategoryStyle(index) {
      if (this.isHomeVersionPremium || this.isHomeVersionBar) {
        return `border-bottom: 2px solid #000;`;
      }

      let backgroundColor =
        index % 2 === 0
          ? `background-color: ${this.secondaryColor}`
          : `background-color: ${this.primaryColor}`;

      return `${backgroundColor}; border-bottom: none`;
    },
    setColor(menu) {
      this.primaryColor = menu.primaryColor ? menu.primaryColor : "";
      this.secondaryColor = menu.secondaryColor ? menu.secondaryColor : "";
    },
    haveDrinks(categoryId) {
      let drinks = this.getDrinksByCategory(categoryId);
      return drinks.length > 0;
    },
    haveFood(categoryId) {
      let food = this.getFoodByCategory(categoryId);
      return food.length > 0;
    },
    haveDessert(categoryId) {
      let dessert = this.getDessertByCategory(categoryId);
      return dessert.length > 0;
    },
    selectEnableTab() {
      let self = this;
      setTimeout(async () => {
        let firstFromTheList = await self.getFirstFromTheSliderList();
        if (firstFromTheList && firstFromTheList?.type === "menus") {
          self.selectProductType(firstFromTheList.id, firstFromTheList.name);
          self.setColor(firstFromTheList);
          return;
        }

        if (firstFromTheList && firstFromTheList?.type === "principal") {
          switch (firstFromTheList.name) {
            case "Postres":
              self.selectProductType(self.productTypeIds.dessert, "Postres");
              self.setColor({
                primaryColor: this.colorsDessertPrimary,
                secondaryColor: this.colorsDessertSecondary
              });
              break;
            case "Bebidas":
              self.selectProductType(self.productTypeIds.drinks, "Bebidas");
              self.setColor({
                primaryColor: this.colorsDrinksPrimary,
                secondaryColor: this.colorsDrinksSecondary
              });
              break;
            case "Comidas":
              self.selectProductType(self.productTypeIds.food, "Comidas");
              self.setColor({
                primaryColor: this.colorsFoodPrimary,
                secondaryColor: this.colorsFoodSecondary
              });
              break;
          }
        }

        if (firstFromTheList && firstFromTheList?.type === "menu_group") {
          this.onMenuGroupTab(firstFromTheList.id, firstFromTheList.name);
          self.setColor(firstFromTheList);
        }
      }, 1000);
    },
    getFirstFromTheSliderList() {
      let firstOption = [...this.sortedSliderList];
      return firstOption && firstOption.length > 0 && firstOption[0]
        ? firstOption[0]
        : null;
    },
    onSelectDrink(selectedDrink, cubataItem) {
      if (selectedDrink) {
        let item = { ...cubataItem };
        if (selectedDrink.isEnergyDrink) {
          item.price += 1;
        }

        item.name += ` + ${selectedDrink.name}`;
        item.orderActual = cubataItem.order;
        item.order += ` - ${selectedDrink.name}`;
        item.order_translations = {
          en:
            this.translateToOneLang("name", item, "en") +
            " + " +
            this.translateToOneLang("name", selectedDrink, "en"),
          es:
            this.translateToOneLang("name", item, "es") +
            " + " +
            this.translateToOneLang("name", selectedDrink, "es"),
          de:
            this.translateToOneLang("name", item, "de") +
            " + " +
            this.translateToOneLang("name", selectedDrink, "de"),
          fr:
            this.translateToOneLang("name", item, "fr") +
            " + " +
            this.translateToOneLang("name", selectedDrink, "fr"),
          it:
            this.translateToOneLang("name", item, "it") +
            " + " +
            this.translateToOneLang("name", selectedDrink, "it")
        };

        if (!this.isAdmin) {
          this.$store.commit("addToCart", { item: item, update: true });
          this.$store.dispatch("addStripeProductToCart", item);
        } else {
          item.cart_type = "admin";
          this.$store.commit("addToCart", { item: item, update: true });
          this.$store.dispatch("addStripeProductToCart", item);
        }
        this.$forceUpdate();
        this.$store.commit("toggleItemListModal");
      }
    },
    getDrinksByCategory(id) {
      if (this.isTypeDrink) {
        return this.drinksCollection.filter(
          drink =>
            id === drink.category_id &&
            drink.stock > 0 &&
            (drink.canBeShowInDrinks === undefined
              ? true
              : drink.canBeShowInDrinks)
        );
      }

      return this.drinksCollection.filter(
        drink => id === drink.category_id && drink.stock > 0
      );
    },
    getFoodByCategory(id) {
      if (this.isTypeFood) {
        return this.foodCollection.filter(
          food =>
            id === food.category_id &&
            food.stock > 0 &&
            (food.canBeShowInFood === undefined ? true : food.canBeShowInFood)
        );
      }

      return this.foodCollection.filter(
        food => id === food.category_id && food.stock > 0
      );
    },
    getDessertByCategory(id) {
      if (this.isTypeDessert) {
        return this.dessertCollection.filter(
          dessert =>
            id === dessert.category_id &&
            dessert.stock > 0 &&
            (dessert.canBeShowInDessert === undefined
              ? true
              : dessert.canBeShowInDessert)
        );
      }
      return this.dessertCollection.filter(
        dessert => id === dessert.category_id && dessert.stock > 0
      );
    },
    selectProductType(id, name) {
      this.productTypeSelected = id;
      this.productTypeSelectedName = name;
      this.selectedMenuGroupName = null;
      this.openPanelForSingleCategory(0);
    },
    toggle(index) {
      if (!this.categories[index].toggleAccordion) {
        this.$set(this.categories[index], "toggleAccordion", true);
      } else {
        this.$set(this.categories[index], "toggleAccordion", false);
      }
    },
    toggleAccordionItem(e) {
      e.target.classList.toggle("expanded");

      const accordionBody = e.target.nextElementSibling;
      if (!accordionBody) {
        return;
      }
      accordionBody.classList.toggle("expanded");

      if (e.target.classList.contains("expanded")) {
        accordionBody.style.maxHeight = `${accordionBody.scrollHeight}px`;
      } else {
        accordionBody.style.maxHeight = 0;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    onTab(productTypeId, productTypeName = "") {
      this.clearSearch();
      this.selectProductType(productTypeId, productTypeName);
      this.closeAccordionBodies();
    },
    openPanelForSingleCategory(time) {
      setTimeout(async () => {
        if (this.categories.length === 1) {
          const elem = this.$refs.accordionItemBtn;
          elem ? elem[0].click() : "";
        }
      }, time);
    },
    closeAccordionBodies() {
      const accordionToggles = document.querySelectorAll(
        ".accordion-item-toggle"
      );
      const accordionBodies = document.querySelectorAll(
        ".accordion-item-content"
      );
      accordionToggles.forEach(toggle => toggle.classList.remove("expanded"));
      accordionBodies.forEach(item => {
        item.style.maxHeight = 0;
        item.classList.remove("expanded");
      });
    },

    universalSearch() {
      const { food, drinks, dessert } = this.$store.state.productTypeIds;

      let allProducts = [];
      let foodProduts = [];
      let dessertProducts = [];
      let drinksProducts = [];

      this.categoriesCollection.forEach(category => {
        foodProduts = this.getFoodByCategory(category.id);
        dessertProducts = this.getDessertByCategory(category.id);
        drinksProducts = this.getDrinksByCategory(category.id);
        allProducts = [
          ...allProducts,
          ...foodProduts.concat(dessertProducts, drinksProducts)
        ];
      });

      let allActiveProductIds = [];

      let filterMenu = this.menus.filter(item => {
        if (!this.disableMenuByMenu(item)) {
          return item;
        }
      });

      filterMenu.forEach(item => {
        allActiveProductIds = [
          ...allActiveProductIds,
          ...item.food_ids,
          ...item.drink_ids,
          ...item.dessert_ids
        ];
      });

      const uniqueProducts = this.getUniqueListBy(allProducts, "id");

      let searchResult = uniqueProducts.filter(product =>
        this.translate("name", product)
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );

      this.searchFoods = [];
      this.searchFoods = searchResult.filter(item => {
        let found = allActiveProductIds.some(prd => prd === item.id);
        if ((item.product_type_id === food && found) || item.canBeShowInFood) {
          return item;
        }
      });

      this.searchDrinks = [];
      this.searchDrinks = searchResult.filter(item => {
        let found = allActiveProductIds.some(prd => prd === item.id);
        if (
          (item.product_type_id === drinks && found) ||
          item.canBeShowInDrinks
        ) {
          return item;
        }
      });

      this.searchPostres = [];
      this.searchPostres = searchResult.filter(item => {
        let found = allActiveProductIds.some(prd => prd === item.id);
        if (
          (item.product_type_id === dessert && found) ||
          item.canBeShowInDessert
        ) {
          return item;
        }
      });

      let result = [];
      result = [
        ...result,
        ...this.searchFoods,
        ...this.searchDrinks,
        ...this.searchPostres
      ];

      this.showEmptyMsg = result.length === 0;
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    clearSearch() {
      this.search = "";
      this.searchDrinks = [];
      this.searchFoods = [];
      this.searchPostres = [];
      this.productTypeSelected = "";
      this.selectedMenuGroup = "";
    },
    haveProducts(menu) {
      if (this.productTypeSelected === menu.id) {
        return (
          [...menu.food_ids, ...menu.drink_ids, ...menu.dessert_ids].length ===
          0
        );
      }
      return false;
    },
    onMenuGroupTab(menuGroupId, menuGroupName = "") {
      this.clearSearch();
      for (let item in this.menuGroup) {
        this.$nextTick(() => {
          document.getElementById(`menugroup_ul_${item}`).style.maxHeight =
            "100%";
        });
      }
      this.selectMenuGroup(menuGroupId, menuGroupName);
    },
    selectMenuGroup(menuGroupId, menuGroupName) {
      this.selectedMenuGroup = menuGroupId;
      this.selectedMenuGroupName = menuGroupName;
      this.productTypeSelectedName = null;
    }
  }
};
</script>
<style scoped lang="scss">
.collapse-title {
  position: relative;
}
.collapse-title svg {
  position: absolute;
  right: 5px;
  top: -1px;
}
::v-deep .v-input__slot {
  border-radius: 50px !important;
}
@media only screen and (min-width: 768px) {
  ::v-deep .mb-div-width {
    margin-left: 10px;
    margin-right: 10px;
  }
}
.img-button {
  width: 60px;
  height: 60px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
}
.search-width {
  width: 90%;
  margin: 0 auto;
}
</style>
